<template>
  <a @click="scrollTop" v-show="visible" class="pos-bottom-right">
    <slot></slot>
  </a>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    scrollTop: function () {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0;
    },
    scrollListener: function () {
      this.visible = window.scrollY > 600;
    },
  },
  mounted: function () {
    window.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy: function () {
    window.removeEventListener("scroll", this.scrollListener);
  },
};
</script>

<style lang="scss" scoped>
.pos-bottom-right {
  position: fixed;
  bottom: 25px;
  right: 25px;
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/components/ScrollToTop.vue